import { twMerge } from "tailwind-merge"

const MaxWidthWrapper = ({ children, className }) => {
  return <div className={twMerge("max-w-375 w-9/10 mx-auto", className)}>{children}</div>
}

export default MaxWidthWrapper
